import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EightByTenExhibitsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M4.474 2a1 1 0 00-1 1v5a1 1 0 001 1h15a1 1 0 001-1V3a1 1 0 00-1-1h-15zm13 5V4h1v3h-1zm-2 0h-1V4h1v3zm-6 0h-1V4h1v3zm3 0h-1V4h1v3zm-6-3v3h-1V4h1zM3 11a1 1 0 00-1 1v9a1 1 0 001 1h10a1 1 0 001-1v-9a1 1 0 00-1-1H3zm4 8v1H4v-1h3zm5-2H9v-1h3v1zm0 3H9v-1h3v1zm-8-3h3v-1H4v1zm8-3H9v-1h3v1zm-8 0h3v-1H4v1zM22 12a1 1 0 00-1-1h-5a1 1 0 00-1 1v9a1 1 0 001 1h5a1 1 0 001-1v-9zm-2 5v-1h-3v1h3zm0 2h-3v1h3v-1zm0-5h-3v-1h3v1z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
EightByTenExhibitsIcon.isCarinaIcon = true;
export default EightByTenExhibitsIcon;
